import { render, staticRenderFns } from "./BaseModalExcluirItemExportacao.vue?vue&type=template&id=2e5ff420&lang=pug"
import script from "./BaseModalExcluirItemExportacao.vue?vue&type=script&lang=js"
export * from "./BaseModalExcluirItemExportacao.vue?vue&type=script&lang=js"
import style0 from "./BaseModalExcluirItemExportacao.vue?vue&type=style&index=0&id=2e5ff420&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports